package com.example.mystybag.sharedmodels.mystyBag.responseModels

import com.example.mystybag.sharedmodels.base.BaseResponseModel
import kotlinx.serialization.Serializable

@Serializable
data class GetUserStoredCardsResponseModel(
    val cards: List<StoredCardModel> = emptyList()
) : BaseResponseModel()

@Serializable
data class StoredCardModel(
    val id: Long,
    val maskedPan: String = "",
    val expDate: String = "",
    val cardToken: String = "",
    val cardCustomName: String = ""
)
